function TagReleaseOrRemovalCtrl($scope, $timeout) {
    $scope.urls = {
        cc2Url: '/ag/updateCc2Tag?accountIds=',
        usUrl: '/ag/updateUsTag?accountIds=',
        cc2AndUsUrl: '/ag/updateCc2AndUsTag?accountIds=',
    }
    $scope.actions = {
        ADD: 'ADD',
        REMOVE: 'REMOVE',
    }

    $scope.endpoints = {
        CC2: 'CC2',
        US: 'US',
        BOTH: 'BOTH',
    }

    $scope.colors = {
        black:'#000000',
        red:'#9E0B0F'
    }

    $scope.addOrRemoveTagRequest = {
        resultColor:$scope.colors.black,
        result: null,
        tag: null,
        accountsIdsStr: null,
        endpoint: $scope.endpoints.CC2,
        action:$scope.actions.ADD,
        placeholder:'Add'
    };

    // TODO:: Lookup US tags
    $scope.tags = [{'name': 'EMAIL_AS_USER_ID'},
                   {'name': 'SCIM_UA_HYBRID'},
                   {'name': 'SCIM_UA'},
                   {'name': 'DEPRECATE_DEVICE_AUTHENTICATION'},
                   {'name': 'USER_SERVICE_SERIALIZE_OBJECT_ID'},
                   {'name': 'USER_SERVICE_USER_AUTHENTICATION'}]

    $scope.sendTagsRequest = function (request) {
        $scope.addOrRemoveTagRequest.result = null

        if ($scope.endpoints.CC2 === request.endpoint) {
            $scope.sendPutRequest($scope.urls.cc2Url, request.accountsIdsStr, request.tag, request.action)
        } else if ($scope.endpoints.US === request.endpoint) {
            $scope.sendPutRequest($scope.urls.usUrl, request.accountsIdsStr, request.tag, request.action)
        } else if ($scope.endpoints.BOTH === request.endpoint) {
            $scope.sendPutRequest($scope.urls.cc2AndUsUrl, request.accountsIdsStr, request.tag, request.action)
        }
    }

    $scope.sendPutRequest = function (url, accountIds, tag, action) {
        return new Promise(() => {
            return store.fetch({
                method: 'PUT',
                url: url + accountIds + '&tag=' + tag.name + '&action=' + action,
                success: function success(data) {
                    $timeout(function () {
                            if (data!= null && data.status !== "ERROR") {
                                $scope.addOrRemoveTagRequest.result = data;
                                $scope.addOrRemoveTagRequest.resultColor = $scope.colors.black;
                            } else {
                                $scope.addOrRemoveTagRequest.result = data.notifications[0]['message'];
                                $scope.addOrRemoveTagRequest.resultColor = $scope.colors.red;
                            }
                    }, 0);
                }
            });
        });
    };

    $scope.oppositeAction = function(action) {
        if ($scope.actions.ADD === action) {
            return $scope.actions.REMOVE
        } else {
            return $scope.actions.ADD
        }
    }


}
